import { Plus } from '@/assets/icons'
import { MattersTable } from './matters-table/MattersTable'
import { MatterDialogType, MattersActions } from '../store/slice'
import { useAppDispatch } from '@/store/store-hooks'
import { Header } from '@/components/header/Header'
import { Button } from '@/components/button/Button'
import { useEffect } from 'react'
import { useIsAccountCollaborationCapable } from '@/collaboration/hooks/useIsAccountCollaborationCapable'
import { usePollWhileVisible } from '@/hooks/usePollWhileVisible'
import { kMatterPollingIntervalMs } from '../constants'

/**
 * Matters Page
 *
 * Main entry point for viewing and managing the user's matters.
 */
export default function MattersPage() {
  const dispatch = useAppDispatch()
  const isAccountCollaborationCapable = useIsAccountCollaborationCapable()

  // Refresh the matter list whenever the page is visited to ensure last_activity_at is up to date
  useEffect(() => {
    dispatch(MattersActions.refreshMatterList({ forceRefresh: true }))
  }, [dispatch])

  // Poll so collaborator changes (e.g. member count) show up without a hard refresh. Only runs for
  // org accounts with collaboration on, since a non-org user has no collaborators to sync from.
  usePollWhileVisible(() => dispatch(MattersActions.refreshMatterList({ forceRefresh: true })), kMatterPollingIntervalMs, isAccountCollaborationCapable)

  return (
    <>
      <div className="flex flex-col flex-1 min-h-0">
        <Header
          title="Matters"
          endInset="button"
          endContent={
            <Button
              size="sm"
              color="primary"
              trailingIcon={<Plus className="w-4 h-4" />}
              onClick={() =>
                dispatch(
                  MattersActions.openDialog({
                    dialogType: MatterDialogType.Create,
                    navigateToMatterOnCreate: true,
                  })
                )
              }
            >
              New Matter
            </Button>
          }
        />

        {/* Table Container (fills remaining space - padding bottom is intentionally 0 to allow the table appear to scroll past the bottom of the page) */}
        <div className="flex-1 min-h-0 px-4 lg:px-10 pt-6 pb-0">
          <MattersTable />
        </div>
      </div>
    </>
  )
}
